export const getNextCursor = (meta) => {
    const { skip, take, total } = meta;
    return skip + take < total ? Math.ceil((skip + take) / take) : undefined;
};
